package net.sergeych.boss_serialization

actual val platfrmSpecificConverters: Iterable<SpecificConverter> = listOf()